export const states: string[] = [
  'Alabama',
  'Alaska',
  'Arizona',
  'Arkansas',
  'California',
  'Colorado',
  'Connecticut',
  'Delaware',
  'Florida',
  'Georgia',
  'Hawaii',
  'Idaho',
  'Illinois',
  'Indiana',
  'Iowa',
  'Kansas',
  'Kentucky',
  'Louisiana',
  'Maine',
  'Maryland',
  'Massachusetts',
  'Michigan',
  'Minnesota',
  'Mississippi',
  'Missouri',
  'Montana',
  'Nebraska',
  'Nevada',
  'New Hampshire',
  'New Jersey',
  'New Mexico',
  'New York',
  'North Carolina',
  'North Dakota',
  'Ohio',
  'Oklahoma',
  'Oregon',
  'Pennsylvania',
  'Rhode Island',
  'South Carolina',
  'South Dakota',
  'Tennessee',
  'Texas',
  'Utah',
  'Vermont',
  'Virginia',
  'Washington',
  'West Virginia',
  'Wisconsin',
  'Wyoming',
];

export const ExpenseCategory: string[] = [
  'Administrative & General (G&A)',
  'Capital Expenditure(CAPEX)',
  'Cost of Goods Sold (COGS) / Direct Costs',
  'Depreciation & Amortization',
  'Financial Expenses',
  'Maintenance & Repairs',
  'Operating Expenses (OPEX)',
  'Payroll & Employee Costs',
  'Sales & Marketing',
  'Taxes & Government Fees',
  'Technology & IT',
  'Transportation & Logistics',
];

export const NotificationTitle = {
  EXPIRATION_NOTIFICATION: 'Expiration Notification',
  EXPIRED_DOCUMENT: 'Expired Document',
  PAYMENT_RECEIVED: 'Payment Received',
  INVOICE_RECEIVED: 'Invoice Received',
  NEW_USER: 'New User',
  NEW_ORDER_RECEIVED: 'New Order Received',
  ORDER_FULFILLED: 'Order Fulfilled',
  NEW_DOCUMENT_RECEIVED: 'New Document Received',
  DOCUMENT_REQUEST: 'Document Request',
  DISPATCH_COMPLETED: 'Dispatch Completed',
} as const;

export type TitleType =
  (typeof NotificationTitle)[keyof typeof NotificationTitle];

export const EditType = {
  EDIT_DATA: 'Edit Data',
  EDIT_ACCESSORY: 'Edit Accessories',
  FINISH_DISPATCH: 'Finish Dispatch',
  CANCEL_DISPATCH: 'Cancel Dispatch',
} as const;

export type EditType = (typeof EditType)[keyof typeof EditType];

export const DispatchPaymentStatus = {
  NOT_FACTORED: 'Not Factored',
  PENDING: 'Pending',
  INVOICED: 'Invoiced',
  PAID: 'Paid',
  EXCEPTION: 'Exception',
} as const;

export type DispatchPaymentStatus =
  (typeof DispatchPaymentStatus)[keyof typeof DispatchPaymentStatus];

export const DispatchStatus = {
  PENDING: 'pending',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
} as const;

export type DispatchStatus =
  (typeof DispatchStatus)[keyof typeof DispatchStatus];

export const StatusType = {
  PENDING: 'Pending',
  ZELE: 'Zele Paid',
  QUICK_BOOK: 'Quick Book Paid',
} as const;

export type StatusType = (typeof StatusType)[keyof typeof StatusType];
